import Repository from './repository';

const resource = '/loginattempt';
export default {
	findUser(payload) {
		return Repository.postWithAuth(
			`${resource}/find/user`,
			payload,
			{},
			{ noCache: true }
		);
	},
	findMe(payload) {
		return Repository.postWithAuth(
			`${resource}/find/me`,
			payload,
			{},
			{ noCache: true }
		);
	},
};
